export default __webpack_public_path__ + "static/media/Anuk-Shakya.55c2e6af.png";